/**
 * @param type: 'request-demo' | 'contact-us', locale: string, url?: String
 * @returns Void
 */

const gtagSolutionIEMS = (
  type: 'request-demo' | 'contact-us',
  locale: string,
  url?: string
): void => {
  const callback = function () {
    if (url) {
      window.location.href = url;
    }
  };

  const code: string = (() => {
    if (type === 'request-demo') {
      if (locale === EnumLocale.ZH_TW) {
        return 'AW-10991029301/SzLFCPvClKgYELWY9_go';
      }
      if (locale === EnumLocale.EN_INT) {
        return 'AW-10991029301/pTqYCPnDlKgYELWY9_go';
      }
    }

    if (type === 'contact-us') {
      if (locale === EnumLocale.ZH_TW) {
        return 'AW-10991029301/KEKkCP7ClKgYELWY9_go';
      }
      if (locale === EnumLocale.EN_INT) {
        return 'AW-10991029301/c7UtCPzDlKgYELWY9_go';
      }
    }

    return '';
  })();

  if (typeof window.gtag === 'function' && code !== '') {
    window.gtag('event', 'conversion', {
      'send_to': code,
      'event_callback': callback,
    });
  }
};

export default gtagSolutionIEMS;
